<div class="modal-header">
  <rask-header size="2">{{ 'TPL_TRANSPORTTILLDELA_TRANSPORTTILLDELNING'
  |translate }}</rask-header>

  <button type="button" class="btn-close close-x" aria-label="Close" (click)="tryClose()">
    <i class="fas fa-times" aria-hidden="true"></i>
  </button>
</div>

<rask-container-block>
  <div class="row">
    <div class="col-12">
      <rask-tpl-transporttilldelning-ao
        [arbetsordrar]="arbetsordrar"
        [transportforetag]="transportforetag"
        [selectedTransportforetag]="selectedTransportforetag"
        (onArbetsorderTilldelad)="onTilldelad($event)">
      </rask-tpl-transporttilldelning-ao>
    </div>
  </div>
  @if (canToggleHandelssortiment()) {
    <div class="row">
      <div class="col-12">
        <div class="dela-btn-container">
          <rask-action-button class="dela-btn"
            (click)="toggleHandelssortiment()"
            icon="fal fa-plus-circle">
            {{ 'TPL_TRANSPORTTILLDELA_DELA_UPP_I_HS' | translate }}
          </rask-action-button>
        </div>
      </div>
    </div>
  }

  @if (displayHandelssortiment()) {
    <div class="row pt-3">
      <div class="col-12">
        <rask-tpl-transporttilldelning-hs
          [arbetsordrar]="arbetsordrar"
          [transportforetag]="transportforetag"
          [displayMode]="handelssortimentDisplayMode">
        </rask-tpl-transporttilldelning-hs>
      </div>
    </div>
  }

  <ng-container footer>
    <div class="footer-btn">
      <rask-save-button (click)="save()" [disabled]="!canSave()"></rask-save-button>
      <rask-button color="secondary" (click)="removeTilldelning()">
      {{ 'TPL_TRANSPORTTILLDELA_REMOVE_TILLDELNING' | translate }}</rask-button>
    </div>
  </ng-container>

</rask-container-block>